module.exports = __webpack_public_path__ + "static/media/TgBaixa.31194ef2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/TgBaixa.svg
// module id = 208
// module chunks = 0